export const FETCHING_AUTORESP_CONTENT = 'FETCHING_AUTORESP_CONTENT';
export const SAVE_AUTORESP_CONTENT = 'SAVE_AUTORESP_CONTENT';
export const EDITING_AUTORESP_CONTENT = 'EDITING_AUTORESP_CONTENT';
export const SAVING_AUTORESP_CONTENT = 'SAVING_AUTORESP_CONTENT';
export const MODIFY_AUTORESP_CONTENT = ' MODIFY_AUTORESP_CONTENT';
export const MODIFY_AUTORESP_STATE = 'MODIFY_AUTORESP_STATE';
export const MODIFYING_AUTORESP_STATE = 'MODIFYING_AUTORESP_STATE';
export const GET_AUTORESP_DATA = 'GET_AUTORESP_DATA';
export const GET_AUTORESP_DATA_FAILED = 'GET_AUTORESP_DATA_FAILED'